// import React, {
//   useEffect,
//   useRef,
//   useState,
// } from 'react';

// import { useParams } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { toPng } from 'html-to-image';

// import './VerifyRegistration.css';

// //Access
// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'https://lsdcnodejs-api.onrender.com';


// /* ==========================================
//    HELPERS
// ========================================== */

// const safeFilePart = (value, fallback = 'PASS') =>
//   String(value || fallback)
//     .trim()
//     .replace(/[^a-z0-9]+/gi, '-')
//     .replace(/^-+|-+$/g, '');


// const waitForImages = async (container) => {
//   if (!container) return;

//   const images = Array.from(
//     container.querySelectorAll('img')
//   );

//   await Promise.all(
//     images.map(async (image) => {
//       if (
//         image.complete &&
//         image.naturalWidth > 0
//       ) {
//         return;
//       }

//       try {
//         if (typeof image.decode === 'function') {
//           await image.decode();
//           return;
//         }
//       } catch {
//         // Fallback to load/error listeners below.
//       }

//       await new Promise((resolve) => {
//         const done = () => resolve();

//         image.addEventListener(
//           'load',
//           done,
//           { once: true }
//         );

//         image.addEventListener(
//           'error',
//           done,
//           { once: true }
//         );
//       });
//     })
//   );
// };


// /* ==========================================
//    PASS CONTENT

//    The same content is used twice:
//    1. Visible responsive pass
//    2. Hidden fixed-size export pass

//    Only the visible pass receives the
//    download button.
// ========================================== */

// function PassContent({
//   record,
//   showDownloadButton = false,
//   downloading = false,
//   downloadError = '',
//   onDownload,
// }) {
//   return (
//     <>
//       <span className="verify-badge">
//         {record.type === 'dignitary'
//           ? 'VERIFIED VIP PASS'
//           : 'VERIFIED STAFF PASS'}
//       </span>

//       <div className="verify-success">
//         ✓
//       </div>

//       {/* {record.title && (
//         <p className="verify-title">
//           {record.title}
//         </p>
//       )} */}

//       <h1 className="verify-name">
//         {record.fullName}
//       </h1>

//       <p className="verify-subtitle">
//         Chief of Staff's Birthday Celebration
//       </p>

//       <div className="verify-info">
//         <div>
//           <span>Registration Code</span>

//           <strong>
//             {record.registrationCode}
//           </strong>
//         </div>

//           {record.title && (
//           <div>
//             <span>
//               Title
//             </span>

//             <strong>
//               {record.title}
//             </strong>
//           </div>
//         )}

//         <div>
//           <span>Category</span>

//           <strong>
//             {record.type === 'dignitary'
//               ? 'VIP'
//               : 'Staff'}
//           </strong>
//         </div>

//         {record.organization && (
//           <div>
//             <span>
//               Ministry / Zone
//             </span>

//             <strong>
//               {record.organization}
//             </strong>
//           </div>
//         )}

//         {record.department && (
//           <div>
//             <span>
//               Department
//             </span>

//             <strong>
//               {record.department}
//             </strong>
//           </div>
//         )}

//         <div>
//           <span>
//             Access
//           </span>

//           <strong>
//             {Array.isArray(record.access)
//               ? record.access.join(' • ')
//               : 'Thanksgiving Service'}
//           </strong>
//         </div>
//       </div>


//       {/* ======================================
//           DOWNLOAD BUTTON
//           AFTER ACCESS / BEFORE QR
//       ====================================== */}

//       {showDownloadButton && (
//         <div className="verify-download-area">
//           <button
//             type="button"
//             className="verify-download-button"
//             onClick={onDownload}
//             disabled={downloading}
//           >
//             <span
//               className="verify-download-icon"
//               aria-hidden="true"
//             >
//               ↓
//             </span>

//             <span>
//               {downloading
//                 ? 'Preparing Pass...'
//                 : 'Download My Pass'}
//             </span>
//           </button>

//           <p className="verify-download-note">
//             Save this pass to your device and
//             present the QR code at the venue.
//           </p>

//           {downloadError && (
//             <div
//               className="verify-download-error"
//               role="alert"
//             >
//               {downloadError}
//             </div>
//           )}
//         </div>
//       )}


//       {/* ======================================
//           QR CODE
//       ====================================== */}

//       {record.qrCode && (
//         <div className="verify-qr-wrap">
//           <img
//             src={record.qrCode}
//             alt={`QR code for ${record.fullName}`}
//             className="verify-qr"
//           />

//           <small>
//             Scan to verify this pass
//           </small>
//         </div>
//       )}


//       <div className="verify-pass-footer">
//         <span>✦</span>

//         <p>
//           COS Birthday Celebration
//         </p>

//         <span>✦</span>
//       </div>
//     </>
//   );
// }


// /* ==========================================
//    VERIFY REGISTRATION
// ========================================== */

// export default function VerifyRegistration() {
//   const {
//     registrationCode,
//   } = useParams();

//   const exportPassRef =
//     useRef(null);

//   const [
//     loading,
//     setLoading,
//   ] = useState(true);

//   const [
//     error,
//     setError,
//   ] = useState('');

//   const [
//     record,
//     setRecord,
//   ] = useState(null);

//   const [
//     downloading,
//     setDownloading,
//   ] = useState(false);

//   const [
//     downloadError,
//     setDownloadError,
//   ] = useState('');


//   /* ==========================================
//      LOAD VERIFIED REGISTRATION
//   ========================================== */

//   useEffect(() => {
//     let cancelled = false;

//     const fetchRegistration =
//       async () => {
//         try {
//           setLoading(true);
//           setError('');

//           const response =
//             await fetch(
//               `${API_URL}/api/birthday/verify/${encodeURIComponent(
//                 registrationCode
//               )}`
//             );

//           const result =
//             await response.json();

//           if (
//             !response.ok ||
//             !result.success
//           ) {
//             throw new Error(
//               result.message ||
//                 'Unable to verify registration.'
//             );
//           }

//           if (!cancelled) {
//             setRecord(
//               result.data
//             );
//           }
//         } catch (err) {
//           if (!cancelled) {
//             setError(
//               err.message ||
//                 'Unable to verify registration.'
//             );
//           }
//         } finally {
//           if (!cancelled) {
//             setLoading(false);
//           }
//         }
//       };

//     if (registrationCode) {
//       fetchRegistration();
//     } else {
//       setLoading(false);
//       setError(
//         'No registration code was supplied.'
//       );
//     }

//     return () => {
//       cancelled = true;
//     };
//   }, [registrationCode]);


//   /* ==========================================
//      DOWNLOAD HIGH-RES PASS

//      IMPORTANT:
//      We do NOT capture the visible mobile card.

//      We capture a second off-screen pass that
//      is permanently rendered at 760px wide.
//      Therefore a phone download cannot shrink
//      the exported design.
//   ========================================== */

//   const handleDownloadPass =
//     async () => {
//       if (
//         !record ||
//         !exportPassRef.current ||
//         downloading
//       ) {
//         return;
//       }

//       setDownloading(true);
//       setDownloadError('');

//       try {
//         const exportNode =
//           exportPassRef.current;

//         /**
//          * Wait for web fonts where supported.
//          */
//         if (document.fonts?.ready) {
//           try {
//             await document.fonts.ready;
//           } catch {
//             // Continue with available fonts.
//           }
//         }

//         /**
//          * Make sure the QR image has loaded
//          * before capturing the export card.
//          */
//         await waitForImages(
//           exportNode
//         );

//         /**
//          * Allow final layout / image dimensions
//          * to settle before capture.
//          */
//         await new Promise((resolve) => {
//           requestAnimationFrame(() => {
//             requestAnimationFrame(resolve);
//           });
//         });

//         const exportWidth = 760;

//         const exportHeight =
//           Math.ceil(
//             exportNode.scrollHeight
//           );

//         const dataUrl =
//           await toPng(
//             exportNode,
//             {
//               cacheBust: true,

//               /**
//                * 760px × 3 = 2280px wide PNG.
//                * Sharp enough for phones and
//                * normal printing.
//                */
//               pixelRatio: 3,

//               width:
//                 exportWidth,

//               height:
//                 exportHeight,

//               backgroundColor:
//                 '#0b0a08',

//               style: {
//                 margin: '0',
//                 transform: 'none',
//               },
//             }
//           );

//         const safeName =
//           safeFilePart(
//             record.fullName,
//             'Guest'
//           );

//         const safeCode =
//           safeFilePart(
//             record.registrationCode,
//             'PASS'
//           );

//         const fileName =
//           `COS-${safeName}-${safeCode}.png`;

//         /**
//          * Convert data URL to Blob.
//          * This is generally more reliable
//          * for downloads than using the
//          * data URL directly.
//          */
//         const imageResponse =
//           await fetch(dataUrl);

//         const imageBlob =
//           await imageResponse.blob();

//         const objectUrl =
//           URL.createObjectURL(
//             imageBlob
//           );

//         const link =
//           document.createElement('a');

//         link.href =
//           objectUrl;

//         link.download =
//           fileName;

//         link.style.display =
//           'none';

//         document.body.appendChild(
//           link
//         );

//         link.click();

//         document.body.removeChild(
//           link
//         );

//         setTimeout(() => {
//           URL.revokeObjectURL(
//             objectUrl
//           );
//         }, 1500);
//       } catch (err) {
//         console.error(
//           'Download pass error:',
//           err
//         );

//         setDownloadError(
//           'Unable to download your pass right now. Please try again.'
//         );
//       } finally {
//         setDownloading(false);
//       }
//     };


//   /* ==========================================
//      LOADING
//   ========================================== */

//   if (loading) {
//     return (
//       <div className="verify-page">
//         <div className="verify-state-card">
//           <div className="verify-state-spinner" />

//           <p>
//             Verifying pass...
//           </p>
//         </div>
//       </div>
//     );
//   }


//   /* ==========================================
//      ERROR
//   ========================================== */

//   if (
//     error ||
//     !record
//   ) {
//     return (
//       <div className="verify-page">
//         <div className="verify-state-card">
//           <div className="verify-state-error">
//             !
//           </div>

//           <h1>
//             Pass Not Found
//           </h1>

//           <p>
//             {error ||
//               'This pass is invalid.'}
//           </p>
//         </div>
//       </div>
//     );
//   }


//   /* ==========================================
//      VERIFIED PASS
//   ========================================== */

//   return (
//     <>
//       <div className="verify-page">
//         <motion.div
//           className="verify-card verify-card--screen"
//           initial={{
//             opacity: 0,
//             y: 24,
//           }}
//           animate={{
//             opacity: 1,
//             y: 0,
//           }}
//           transition={{
//             duration: 0.45,
//           }}
//         >
//           <PassContent
//             record={record}
//             showDownloadButton
//             downloading={downloading}
//             downloadError={downloadError}
//             onDownload={handleDownloadPass}
//           />
//         </motion.div>
//       </div>


//       {/* ======================================
//           OFF-SCREEN EXPORT PASS

//           Never display:none / visibility:hidden.
//           html-to-image needs it fully rendered.

//           It is placed far outside the viewport
//           and is NOT visible to the user.
//       ====================================== */}

//       <div
//         className="verify-export-host"
//         aria-hidden="true"
//       >
//         <div
//           ref={exportPassRef}
//           className="verify-card verify-card--export"
//         >
//           <PassContent
//             record={record}
//           />
//         </div>
//       </div>
//     </>
//   );
// }

//PBA



// import React, {
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from 'react';

// import {
//   motion,
// } from 'framer-motion';

// import {
//   useParams,
// } from 'react-router-dom';

// import {
//   toPng,
// } from 'html-to-image';

// import './VerifyRegistration.css';


// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'https://lsdcnodejs-api.onrender.com';

// //COS BIRTHDAY CELEBRATION
// /*
//  * Put this image in:
//  *
//  * public/images/cos/bisola-1.jpg
//  *
//  * You can change the path if your filename is different.
//  */
// const PASS_HERO_IMAGE =
//   '/assets/photos/PBA_14.png';


// /* =========================================================
//    HELPERS
// ========================================================= */

// const safeFilePart = (
//   value,
//   fallback = 'PASS'
// ) =>
//   String(
//     value ||
//     fallback
//   )
//     .trim()
//     .replace(
//       /[^a-z0-9]+/gi,
//       '-'
//     )
//     .replace(
//       /^-+|-+$/g,
//       ''
//     );
// //Download

// const waitForImages =
//   async (
//     container
//   ) => {
//     if (!container) {
//       return;
//     }


//     const images =
//       Array.from(
//         container.querySelectorAll(
//           'img'
//         )
//       );


//     await Promise.all(
//       images.map(
//         async (
//           image
//         ) => {

//           if (
//             image.complete &&
//             image.naturalWidth >
//               0
//           ) {
//             return;
//           }


//           try {

//             if (
//               typeof image.decode ===
//               'function'
//             ) {

//               await image.decode();

//               return;

//             }

//           } catch {
//             // Continue to load/error listener.
//           }


//           await new Promise(
//             (
//               resolve
//             ) => {

//               const done =
//                 () =>
//                   resolve();


//               image.addEventListener(
//                 'load',
//                 done,
//                 {
//                   once:
//                     true,
//                 }
//               );


//               image.addEventListener(
//                 'error',
//                 done,
//                 {
//                   once:
//                     true,
//                 }
//               );

//             }
//           );

//         }
//       )
//     );
//   };


// const getPassMeta =
//   (
//     record
//   ) => {

//     const isDignitary =
//       record
//         ?.type ===
//       'dignitary';


//     const level =
//       String(
//         record
//           ?.dignitaryLevel ||
//         (
//           isDignitary
//             ? 'VIP'
//             : 'STAFF'
//         )
//       )
//         .trim()
//         .toUpperCase();


//     if (
//       isDignitary &&
//       level ===
//         'VVIP'
//     ) {

//       return {
//         key:
//           'vvip',

//         badge:
//           'VERIFIED VVIP PASS',

//         category:
//           'VVIP',

//         accessTitle:
//           'Thanksgiving & Banquet',

//         accentLabel:
//           'GOLD ACCESS',
//       };

//     }


//     if (
//       isDignitary
//     ) {

//       return {
//         key:
//           'vip',

//         badge:
//           'VERIFIED VIP PASS',

//         category:
//           'VIP',

//         accessTitle:
//           'Thanksgiving & Banquet',

//         accentLabel:
//           'PURPLE ACCESS',
//       };

//     }


//     return {
//       key:
//         'staff',

//       badge:
//         'VERIFIED STAFF PASS',

//       category:
//         'STAFF',

//       accessTitle:
//         'Thanksgiving Service',

//       accentLabel:
//         'STAFF ACCESS',
//     };

//   };


// /* =========================================================
//    PASS CONTENT

//    Used twice:
//    1. visible responsive pass
//    2. hidden fixed-width export pass
// ========================================================= */

// function PassContent({
//   record,
//   showDownloadButton = false,
//   downloading = false,
//   downloadError = '',
//   onDownload,
// }) {

//   const passMeta =
//     getPassMeta(
//       record
//     );


//   const accessItems =
//     Array.isArray(
//       record.access
//     ) &&
//     record.access.length >
//       0
//       ? record.access
//       : record.type ===
//         'dignitary'
//       ? [
//           'Thanksgiving Service',
//           'Reception / Banquet',
//         ]
//       : [
//           'Thanksgiving Service',
//         ];


//   return (
//     <>

//       {/* =====================================================
//           HERO / EVENT IDENTITY
//       ===================================================== */}

//       <header className="verify-hero">

//         <img
//           src={
//             PASS_HERO_IMAGE
//           }
//           alt="Pastor Bisola Adeyemi"
//           className="verify-hero-image"
//         />


//         <div className="verify-hero-shade" />


//         <div className="verify-hero-topline">

//           <div className="verify-event-mark">

//             <span>
//               PBA
//             </span>

//             <small>
//               06 · 10 · 26
//             </small>

//           </div>


//           <span
//             className={`verify-category-chip verify-category-chip--${passMeta.key}`}
//           >
//             {
//               passMeta.category
//             }
//           </span>

//         </div>


//         <div className="verify-hero-copy">
// {/* 
//           <span>
//             COS BIRTHDAY CELEBRATION
//           </span> */}


//           <h2>
//             Thanksgiving
//             <em>
//               {' & '}
//             </em>
//             Banquet
//           </h2>


//           <p>
//             In honour of the Highly Esteemed
//             Pastor Bisola Adeyemi
//           </p>

//         </div>

//       </header>


//       {/* =====================================================
//           VERIFIED IDENTITY
//       ===================================================== */}

//       <section className="verify-content">

//         <div className="verify-pass-status">

//           <span
//             className={`verify-badge verify-badge--${passMeta.key}`}
//           >
//             {
//               passMeta.badge
//             }
//           </span>


//           <div className="verify-success">
//             ✓
//           </div>


//           <span className="verify-status-copy">
//             AUTHENTICATED EVENT CREDENTIAL
//           </span>

//         </div>


//         {record.title && (
//           <p className="verify-title">
//             {
//               record.title
//             }
//           </p>
//         )}


//         <h1 className="verify-name">
//           {
//             record.fullName
//           }
//         </h1>


//         <p className="verify-subtitle">
//           This personalised pass confirms
//           your registration and event access.
//         </p>


//         {/* ===================================================
//             PASS DATA
//         =================================================== */}

//         <div className="verify-ticket-grid">

//           <article className="verify-ticket-item">

//             <span>
//               REGISTRATION CODE
//             </span>

//             <strong className="verify-code-value">
//               {
//                 record.registrationCode
//               }
//             </strong>

//           </article>


//           <article className="verify-ticket-item">

//             <span>
//               CATEGORY
//             </span>

//             <strong>
//               {
//                 passMeta.category
//               }
//             </strong>

//             <small>
//               {
//                 passMeta.accentLabel
//               }
//             </small>

//           </article>


//           <article className="verify-ticket-item verify-ticket-item--wide">

//             <span>
//               EVENT ACCESS
//             </span>

//             <strong>
//               {
//                 passMeta.accessTitle
//               }
//             </strong>

//           </article>

//         </div>


//         {/* ===================================================
//             EVENT INFORMATION
//         =================================================== */}

//         <section className="verify-event-details">

//           <div className="verify-event-heading">

//             <span>
//               EVENT DETAILS
//             </span>

//             <b>
//               ✦
//             </b>

//           </div>


//           <div className="verify-event-row">

//             <div className="verify-event-icon">
//               29
//             </div>

//             <div>

//               <small>
//                 DATE
//               </small>

//               <strong>
//                 Tuesday, 6th October 2026
//               </strong>

//             </div>

//           </div>


//           <div className="verify-event-row">

//             <div className="verify-event-icon">
//               10
//             </div>

//             <div>

//               <small>
//                 THANKSGIVING SERVICE
//               </small>

//               <strong>
//                 Bay 4 · 10:00 AM Prompt
//               </strong>

//             </div>

//           </div>


//           {record.type ===
//             'dignitary' && (

//             <div className="verify-event-row">

//               <div className="verify-event-icon">
//                 ✦
//               </div>

//               <div>

//                 <small>
//                   BANQUET
//                 </small>

//                 <strong>
//                   The Angel Court
//                 </strong>

//                 <em>
//                   Immediately after the Thanksgiving Service
//                 </em>

//               </div>

//             </div>

//           )}

//         </section>


//         {/* ===================================================
//             ACCESS LIST
//         =================================================== */}

//         <section className="verify-access">

//           <div className="verify-access-head">

//             <span>
//               YOUR ACCESS
//             </span>

//             <small>
//               PRESENT THIS PASS AT THE VENUE
//             </small>

//           </div>


//           <div className="verify-access-list">

//             {accessItems.map(
//               (
//                 item
//               ) => (

//                 <div
//                   className="verify-access-row"
//                   key={
//                     item
//                   }
//                 >

//                   <span className="verify-access-check">
//                     ✓
//                   </span>

//                   <strong>
//                     {
//                       item
//                     }
//                   </strong>

//                 </div>

//               )
//             )}

//           </div>

//         </section>


//         {/* ===================================================
//             OPTIONAL ORGANISATION DATA
//         =================================================== */}

//         {(
//           record.organization ||
//           record.department
//         ) && (

//           <section className="verify-extra-info">

//             {record.organization && (

//               <div>

//                 <span>
//                   Ministry / Zone
//                 </span>

//                 <strong>
//                   {
//                     record.organization
//                   }
//                 </strong>

//               </div>

//             )}


//             {record.department && (

//               <div>

//                 <span>
//                   Department
//                 </span>

//                 <strong>
//                   {
//                     record.department
//                   }
//                 </strong>

//               </div>

//             )}

//           </section>

//         )}


//         {/* ===================================================
//             DOWNLOAD
//         =================================================== */}

//         {showDownloadButton && (

//           <div className="verify-download-area">

//             <button
//               type="button"
//               className="verify-download-button"
//               onClick={
//                 onDownload
//               }
//               disabled={
//                 downloading
//               }
//             >

//               <span
//                 className="verify-download-icon"
//                 aria-hidden="true"
//               >
//                 ↓
//               </span>


//               <span>
//                 {downloading
//                   ? 'Preparing Pass...'
//                   : 'Download My Event Pass'}
//               </span>

//             </button>


//             <p className="verify-download-note">
//               Save the pass to your phone.
//               The QR code will be scanned at
//               the event entrance.
//             </p>


//             {downloadError && (

//               <div
//                 className="verify-download-error"
//                 role="alert"
//               >
//                 {
//                   downloadError
//                 }
//               </div>

//             )}

//           </div>

//         )}


//         {/* ===================================================
//             QR
//         =================================================== */}

//         {record.qrCode && (

//           <section
//             className={`verify-qr-section verify-qr-section--${passMeta.key}`}
//           >

//             <div className="verify-qr-heading">

//               <span>
//                 SECURE ENTRY QR
//               </span>

//               <small>
//                 Do not share your private pass
//               </small>

//             </div>


//             <div className="verify-qr-frame">

//               <span className="verify-qr-corner verify-qr-corner--tl" />
//               <span className="verify-qr-corner verify-qr-corner--tr" />
//               <span className="verify-qr-corner verify-qr-corner--bl" />
//               <span className="verify-qr-corner verify-qr-corner--br" />


//               <img
//                 src={
//                   record.qrCode
//                 }
//                 alt={`QR code for ${record.fullName}`}
//                 className="verify-qr"
//               />

//             </div>


//             <strong className="verify-qr-code">
//               {
//                 record.registrationCode
//               }
//             </strong>


//             <small className="verify-qr-note">
//               Scan to verify this pass
//             </small>

//           </section>

//         )}


//         {/* ===================================================
//             FOOTER
//         =================================================== */}

//         <footer className="verify-pass-footer">

//           <div className="verify-footer-line" />

//           <div>

//             <span>
//               ✦
//             </span>

//             <p>
//               COS Birthday Celebration
//             </p>

//             <span>
//               ✦
//             </span>

//           </div>


//           <small>
//             Private personalised credential ·
//             Intended recipient only
//           </small>

//         </footer>

//       </section>

//     </>
//   );
// }


// /* =========================================================
//    VERIFY REGISTRATION
// ========================================================= */

// export default function VerifyRegistration() {

//   const {
//     registrationCode,
//   } =
//     useParams();


//   const exportPassRef =
//     useRef(
//       null
//     );


//   const [
//     loading,
//     setLoading,
//   ] =
//     useState(
//       true
//     );


//   const [
//     error,
//     setError,
//   ] =
//     useState(
//       ''
//     );


//   const [
//     record,
//     setRecord,
//   ] =
//     useState(
//       null
//     );


//   const [
//     downloading,
//     setDownloading,
//   ] =
//     useState(
//       false
//     );


//   const [
//     downloadError,
//     setDownloadError,
//   ] =
//     useState(
//       ''
//     );


//   /* =========================================================
//      FETCH REGISTRATION
//   ========================================================= */

//   useEffect(
//     () => {

//       let cancelled =
//         false;


//       const fetchRegistration =
//         async () => {

//           try {

//             setLoading(
//               true
//             );


//             setError(
//               ''
//             );


//             if (
//               !registrationCode
//             ) {

//               throw new Error(
//                 'No registration code was supplied.'
//               );

//             }


//             const response =
//               await fetch(
//                 `${API_URL}/api/birthday/verify/${encodeURIComponent(
//                   registrationCode
//                 )}`
//               );


//             let result =
//               {};


//             try {

//               result =
//                 await response.json();

//             } catch {

//               result =
//                 {};

//             }


//             if (
//               !response.ok ||
//               !result.success
//             ) {

//               throw new Error(
//                 result.message ||
//                 'Unable to verify registration.'
//               );

//             }


//             if (
//               !cancelled
//             ) {

//               setRecord(
//                 result.data
//               );

//             }

//           } catch (
//             err
//           ) {

//             if (
//               !cancelled
//             ) {

//               setError(
//                 err.message ||
//                 'Unable to verify registration.'
//               );

//             }

//           } finally {

//             if (
//               !cancelled
//             ) {

//               setLoading(
//                 false
//               );

//             }

//           }

//         };


//       fetchRegistration();


//       return () => {

//         cancelled =
//           true;

//       };

//     },
//     [
//       registrationCode,
//     ]
//   );


//   /* =========================================================
//      PASS META
//   ========================================================= */

//   const passMeta =
//     useMemo(
//       () =>
//         record
//           ? getPassMeta(
//               record
//             )
//           : null,
//       [
//         record,
//       ]
//     );


//   /* =========================================================
//      HIGH RESOLUTION DOWNLOAD
//   ========================================================= */

//   const handleDownloadPass =
//     async () => {

//       if (
//         !record ||
//         !exportPassRef.current ||
//         downloading
//       ) {

//         return;

//       }


//       setDownloading(
//         true
//       );


//       setDownloadError(
//         ''
//       );


//       try {

//         const exportNode =
//           exportPassRef.current;


//         if (
//           document.fonts
//             ?.ready
//         ) {

//           try {

//             await document.fonts.ready;

//           } catch {
//             // Continue.
//           }

//         }


//         await waitForImages(
//           exportNode
//         );


//         await new Promise(
//           (
//             resolve
//           ) => {

//             requestAnimationFrame(
//               () => {

//                 requestAnimationFrame(
//                   resolve
//                 );

//               }
//             );

//           }
//         );


//         const exportWidth =
//           760;


//         const exportHeight =
//           Math.ceil(
//             exportNode.scrollHeight
//           );


//         const dataUrl =
//           await toPng(
//             exportNode,
//             {
//               cacheBust:
//                 true,

//               pixelRatio:
//                 3,

//               width:
//                 exportWidth,

//               height:
//                 exportHeight,

//               backgroundColor:
//                 '#f3dfad',

//               style: {
//                 margin:
//                   '0',

//                 transform:
//                   'none',
//               },
//             }
//           );


//         const safeName =
//           safeFilePart(
//             record.fullName,
//             'Guest'
//           );


//         const safeCode =
//           safeFilePart(
//             record.registrationCode,
//             'PASS'
//           );


//         const category =
//           safeFilePart(
//             passMeta
//               ?.category ||
//             'PASS',
//             'PASS'
//           );


//         const fileName =
//           `COS-${category}-${safeName}-${safeCode}.png`;


//         const imageResponse =
//           await fetch(
//             dataUrl
//           );


//         const imageBlob =
//           await imageResponse.blob();


//         const objectUrl =
//           URL.createObjectURL(
//             imageBlob
//           );


//         const link =
//           document.createElement(
//             'a'
//           );


//         link.href =
//           objectUrl;


//         link.download =
//           fileName;


//         link.style.display =
//           'none';


//         document.body.appendChild(
//           link
//         );


//         link.click();


//         document.body.removeChild(
//           link
//         );


//         window.setTimeout(
//           () => {

//             URL.revokeObjectURL(
//               objectUrl
//             );

//           },
//           1500
//         );

//       } catch (
//         err
//       ) {

//         console.error(
//           'Download pass error:',
//           err
//         );


//         setDownloadError(
//           'Unable to download your pass right now. Please try again.'
//         );

//       } finally {

//         setDownloading(
//           false
//         );

//       }

//     };


//   /* =========================================================
//      LOADING
//   ========================================================= */

//   if (
//     loading
//   ) {

//     return (
//       <div className="verify-page">

//         <div className="verify-state-card">

//           <div className="verify-state-spinner" />


//           <span>
//             COS BIRTHDAY CELEBRATION
//           </span>


//           <h2>
//             Verifying Your Pass
//           </h2>


//           <p>
//             Please wait while we authenticate
//             your personalised event credential.
//           </p>

//         </div>

//       </div>
//     );

//   }


//   /* =========================================================
//      ERROR
//   ========================================================= */

//   if (
//     error ||
//     !record
//   ) {

//     return (
//       <div className="verify-page">

//         <div className="verify-state-card">

//           <div className="verify-state-error">
//             !
//           </div>


//           <span>
//             PRIVATE EVENT ACCESS
//           </span>


//           <h2>
//             Pass Not Found
//           </h2>


//           <p>
//             {
//               error ||
//               'This pass is invalid.'
//             }
//           </p>

//         </div>

//       </div>
//     );

//   }


//   /* =========================================================
//      VERIFIED PASS
//   ========================================================= */

//   return (
//     <>

//       <div
//         className={`verify-page verify-page--${passMeta.key}`}
//       >

//         <motion.div
//           className={`verify-card verify-card--screen verify-card--${passMeta.key}`}
//           initial={{
//             opacity:
//               0,

//             y:
//               24,

//             scale:
//               0.985,
//           }}
//           animate={{
//             opacity:
//               1,

//             y:
//               0,

//             scale:
//               1,
//           }}
//           transition={{
//             duration:
//               0.5,
//           }}
//         >

//           <PassContent
//             record={
//               record
//             }
//             showDownloadButton
//             downloading={
//               downloading
//             }
//             downloadError={
//               downloadError
//             }
//             onDownload={
//               handleDownloadPass
//             }
//           />

//         </motion.div>

//       </div>


//       {/* =====================================================
//           OFF-SCREEN FIXED WIDTH EXPORT
//       ===================================================== */}

//       <div
//         className="verify-export-host"
//         aria-hidden="true"
//       >

//         <div
//           ref={
//             exportPassRef
//           }
//           className={`verify-card verify-card--export verify-card--${passMeta.key}`}
//         >

//           <PassContent
//             record={
//               record
//             }
//           />

//         </div>

//       </div>

//     </>
//   );
// }

//verifyRegistration


import React, {

  useEffect,

  useMemo,

  useRef,

  useState,

} from 'react';

import {

  motion,

} from 'framer-motion';

import {

  useParams,

} from 'react-router-dom';

import {

  toPng,

} from 'html-to-image';

import './VerifyRegistration.css';

const LOCAL_API_URL = 'http://localhost:3001';
const LIVE_API_URL = 'https://lsdcnodejs-api.onrender.com';
const isLocalhost = typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '::1', '[::1]'].includes(window.location.hostname);
const API_URL = String(
  process.env.REACT_APP_API_URL ||
  (isLocalhost
    ? process.env.REACT_APP_LOCAL_API_URL || LOCAL_API_URL
    : process.env.REACT_APP_LIVE_API_URL || LIVE_API_URL)
).trim().replace(/\/+$/, '');

//COS BIRTHDAY CELEBRATION

/*

 \* Put this image in:

 \*

 \* public/images/cos/bisola-1.jpg

 \*

 \* You can change the path if your filename is different.

 */

const PASS_HERO_IMAGE =

  '/assets/photos/PBA_14.png';

/* =========================================================

   HELPERS

========================================================= */

const safeFilePart = (

  value,

  fallback = 'PASS'

) =>

  String(

    value ||

    fallback

  )

    .trim()

    .replace(

      /[^a-z0-9]+/gi,

      '-'

    )

    .replace(

      /^-+|-+$/g,

      ''

    );

//Download

const waitForImages =

  async (

    container

  ) => {

    if (!container) {

      return;

    }

    const images =

      Array.from(

        container.querySelectorAll(

          'img'

        )

      );

    await Promise.all(

      images.map(

        async (

          image

        ) => {

          if (

            image.complete &&

            image.naturalWidth >

              0

          ) {

            return;

          }

          try {

            if (

              typeof image.decode ===

              'function'

            ) {

              await image.decode();

              return;

            }

          } catch {

            // Continue to load/error listener.

          }

          await new Promise(

            (

              resolve

            ) => {

              const done =

                () =>

                  resolve();

              image.addEventListener(

                'load',

                done,

                {

                  once:

                    true,

                }

              );

              image.addEventListener(

                'error',

                done,

                {

                  once:

                    true,

                }

              );

            }

          );

        }

      )

    );

  };

const getPassMeta =

  (

    record

  ) => {

    const isDignitary =

      record

        ?.type ===

      'dignitary';

    const level =

      String(

        record

          ?.dignitaryLevel ||

        (

          isDignitary

            ? 'VIP'

            : 'STAFF'

        )

      )

        .trim()

        .toUpperCase();

    if (

      isDignitary &&

      level ===

        'VVIP'

    ) {

      return {

        key:

          'vvip',

        badge:

          'VERIFIED VVIP PASS',

        category:

          'VVIP',

        accessTitle:

          'Thanksgiving & Banquet',

        accentLabel:

          'GOLD ACCESS',

      };

    }

    if (

      isDignitary

    ) {

      return {

        key:

          'vip',

        badge:

          'VERIFIED VIP PASS',

        category:

          'VIP',

        accessTitle:

          'Thanksgiving & Banquet',

        accentLabel:

          'PURPLE ACCESS',

      };

    }

    return {

      key:

        'staff',

      badge:

        'VERIFIED STAFF PASS',

      category:

        'STAFF',

      accessTitle:

        'Thanksgiving Service',

      accentLabel:

        'STAFF ACCESS',

    };

  };

/* =========================================================

   PASS CONTENT

   Used twice:

   1. visible responsive pass

   2. hidden fixed-width export pass

========================================================= */

function PassContent({

  record,

  showDownloadButton = false,

  downloading = false,

  downloadError = '',

  onDownload,

}) {

  const passMeta =

    getPassMeta(

      record

    );

  const accessItems =

    Array.isArray(

      record.access

    ) &&

    record.access.length >

      0

      ? record.access

      : record.type ===

        'dignitary'

      ? [

          'Thanksgiving Service',

          'Reception / Banquet',

        ]

      : [

          'Thanksgiving Service',

        ];

  return (

    <>

      {/* =====================================================

          HERO / EVENT IDENTITY

      ===================================================== */}

      <header className="verify-hero">

        <img

          src={

            PASS_HERO_IMAGE

          }

          alt="Pastor Bisola Adeyemi"

          className="verify-hero-image"

        />

        <div className="verify-hero-shade" />

        <div className="verify-hero-topline">

          <div className="verify-event-mark">

            <span>

              PBA

            </span>

            <small>

              29 · 09 · 26

            </small>

          </div>

          <span

            className={`verify-category-chip verify-category-chip--${passMeta.key}`}

          >

            {

              passMeta.category

            }

          </span>

        </div>

        <div className="verify-hero-copy">

{/* 

          <span>

            COS BIRTHDAY CELEBRATION

          </span> */}

          <h2>

            Thanksgiving

            <em>

              {' & '}

            </em>

            Banquet

          </h2>

          <p>

            In honour of the Highly Esteemed

            Pastor Bisola Adeyemi

          </p>

        </div>

      </header>

      {/* =====================================================

          VERIFIED IDENTITY

      ===================================================== */}

      <section className="verify-content">

        <div className="verify-pass-status">

          <span

            className={`verify-badge verify-badge--${passMeta.key}`}

          >

            {

              passMeta.badge

            }

          </span>

          <div className="verify-success">

            ✓

          </div>

          <span className="verify-status-copy">

            AUTHENTICATED EVENT CREDENTIAL

          </span>

        </div>

        {record.title && (

          <p className="verify-title">

            {

              record.title

            }

          </p>

        )}

        <h1 className="verify-name">

          {

            record.fullName

          }

        </h1>

        <p className="verify-subtitle">

          This personalised pass confirms

          your registration and event access.

        </p>

        {/* ===================================================

            PASS DATA

        =================================================== */}

        <div className="verify-ticket-grid">

          <article className="verify-ticket-item">

            <span>

              REGISTRATION CODE

            </span>

            <strong className="verify-code-value">

              {

                record.registrationCode

              }

            </strong>

          </article>

          <article className="verify-ticket-item">

            <span>

              CATEGORY

            </span>

            <strong>

              {

                passMeta.category

              }

            </strong>

            <small>

              {

                passMeta.accentLabel

              }

            </small>

          </article>

          <article className="verify-ticket-item verify-ticket-item--wide">

            <span>

              EVENT ACCESS

            </span>

            <strong>

              {

                passMeta.accessTitle

              }

            </strong>

          </article>

        {record.type === 'dignitary' &&
          String(record.dignitaryLevel || '').trim().toUpperCase() === 'VVIP' && (
            <article className="verify-ticket-item verify-ticket-item--wide">
              <span>BANQUET TABLE NAME</span>
              <strong style={{ color: '#d9bb74', overflowWrap: 'anywhere' }}>
                {String(record.tableName || '').trim() || 'Pending assignment'}
              </strong>
              <small>
                {record.tableName
                  ? 'YOUR RESERVED VVIP TABLE'
                  : 'PLEASE CONTACT THE ORGANISING COMMITTEE'}
              </small>
            </article>
          )}

        </div>

        {/* ===================================================

            EVENT INFORMATION

        =================================================== */}

        <section className="verify-event-details">

          <div className="verify-event-heading">

            <span>

              EVENT DETAILS

            </span>

            <b>

              ✦

            </b>

          </div>

          <div className="verify-event-row">

            <div className="verify-event-icon">

              29

            </div>

            <div>

              <small>

                DATE

              </small>

              <strong>

                Tuesday, 6th October 2026

              </strong>

            </div>

          </div>

          <div className="verify-event-row">

            <div className="verify-event-icon">

              10

            </div>

            <div>

              <small>

                THANKSGIVING SERVICE

              </small>

              <strong>

                Bay 4 · 10:00 AM Prompt

              </strong>

            </div>

          </div>

          {record.type ===

            'dignitary' && (

            <div className="verify-event-row">

              <div className="verify-event-icon">

                ✦

              </div>

              <div>

                <small>

                  BANQUET

                </small>

                <strong>

                  The Angel Court

                </strong>

                <em>

                  Immediately after the Thanksgiving Service

                </em>

              </div>

            </div>

          )}

        </section>

        {/* ===================================================

            ACCESS LIST

        =================================================== */}

        <section className="verify-access">

          <div className="verify-access-head">

            <span>

              YOUR ACCESS

            </span>

            <small>

              PRESENT THIS PASS AT THE VENUE

            </small>

          </div>

          <div className="verify-access-list">

            {accessItems.map(

              (

                item

              ) => (

                <div

                  className="verify-access-row"

                  key={

                    item

                  }

                >

                  <span className="verify-access-check">

                    ✓

                  </span>

                  <strong>

                    {

                      item

                    }

                  </strong>

                </div>

              )

            )}

          </div>

        </section>

        {/* ===================================================

            OPTIONAL ORGANISATION DATA

        =================================================== */}

        {(

          record.organization ||

          record.department

        ) && (

          <section className="verify-extra-info">

            {record.organization && (

              <div>

                <span>

                  Ministry / Zone

                </span>

                <strong>

                  {

                    record.organization

                  }

                </strong>

              </div>

            )}

            {record.department && (

              <div>

                <span>

                  Department

                </span>

                <strong>

                  {

                    record.department

                  }

                </strong>

              </div>

            )}

          </section>

        )}

        {/* ===================================================

            DOWNLOAD

        =================================================== */}

        {showDownloadButton && (

          <div className="verify-download-area">

            <button

              type="button"

              className="verify-download-button"

              onClick={

                onDownload

              }

              disabled={

                downloading

              }

            >

              <span

                className="verify-download-icon"

                aria-hidden="true"

              >

                ↓

              </span>

              <span>

                {downloading

                  ? 'Preparing Pass...'

                  : 'Download My Event Pass'}

              </span>

            </button>

            <p className="verify-download-note">

              Save the pass to your phone.

              The QR code will be scanned at

              the event entrance.

            </p>

            {downloadError && (

              <div

                className="verify-download-error"

                role="alert"

              >

                {

                  downloadError

                }

              </div>

            )}

          </div>

        )}

        {/* ===================================================

            QR

        =================================================== */}

        {record.qrCode && (

          <section

            className={`verify-qr-section verify-qr-section--${passMeta.key}`}

          >

            <div className="verify-qr-heading">

              <span>

                SECURE ENTRY QR

              </span>

              <small>

                Do not share your private pass

              </small>

            </div>

            <div className="verify-qr-frame">

              <span className="verify-qr-corner verify-qr-corner--tl" />

              <span className="verify-qr-corner verify-qr-corner--tr" />

              <span className="verify-qr-corner verify-qr-corner--bl" />

              <span className="verify-qr-corner verify-qr-corner--br" />

              <img

                src={

                  record.qrCode

                }

                alt={`QR code for ${record.fullName}`}

                className="verify-qr"

              />

            </div>

            <strong className="verify-qr-code">

              {

                record.registrationCode

              }

            </strong>

            <small className="verify-qr-note">

              Scan to verify this pass

            </small>

          </section>

        )}

        {/* ===================================================

            FOOTER

        =================================================== */}

        <footer className="verify-pass-footer">

          <div className="verify-footer-line" />

          <div>

            <span>

              ✦

            </span>

            <p>

              COS Birthday Celebration

            </p>

            <span>

              ✦

            </span>

          </div>

          <small>

            Private personalised credential ·

            Intended recipient only

          </small>

        </footer>

      </section>

    </>

  );

}

/* =========================================================

   VERIFY REGISTRATION

========================================================= */

export default function VerifyRegistration() {

  const {

    registrationCode,

  } =

    useParams();

  const exportPassRef =

    useRef(

      null

    );

  const [

    loading,

    setLoading,

  ] =

    useState(

      true

    );

  const [

    error,

    setError,

  ] =

    useState(

      ''

    );

  const [

    record,

    setRecord,

  ] =

    useState(

      null

    );

  const [

    downloading,

    setDownloading,

  ] =

    useState(

      false

    );

  const [

    downloadError,

    setDownloadError,

  ] =

    useState(

      ''

    );

  /* =========================================================

     FETCH REGISTRATION

  ========================================================= */

  useEffect(

    () => {

      let cancelled =

        false;

      const fetchRegistration =

        async () => {

          try {

            setLoading(

              true

            );

            setError(

              ''

            );

            if (

              !registrationCode

            ) {

              throw new Error(

                'No registration code was supplied.'

              );

            }

            const response =

              await fetch(

                `${API_URL}/api/birthday/verify/${encodeURIComponent(

                  registrationCode

                )}`

              );

            let result =

              {};

            try {

              result =

                await response.json();

            } catch {

              result =

                {};

            }

            if (

              !response.ok ||

              !result.success

            ) {

              throw new Error(

                result.message ||

                'Unable to verify registration.'

              );

            }

            if (

              !cancelled

            ) {

              setRecord(

                result.data

              );

            }

          } catch (

            err

          ) {

            if (

              !cancelled

            ) {

              setError(

                err.message ||

                'Unable to verify registration.'

              );

            }

          } finally {

            if (

              !cancelled

            ) {

              setLoading(

                false

              );

            }

          }

        };

      fetchRegistration();

      return () => {

        cancelled =

          true;

      };

    },

    [

      registrationCode,

    ]

  );

  /* =========================================================

     PASS META

  ========================================================= */

  const passMeta =

    useMemo(

      () =>

        record

          ? getPassMeta(

              record

            )

          : null,

      [

        record,

      ]

    );

  /* =========================================================

     HIGH RESOLUTION DOWNLOAD

  ========================================================= */

  const handleDownloadPass =

    async () => {

      if (

        !record ||

        !exportPassRef.current ||

        downloading

      ) {

        return;

      }

      setDownloading(

        true

      );

      setDownloadError(

        ''

      );

      try {

        const exportNode =

          exportPassRef.current;

        if (

          document.fonts

            ?.ready

        ) {

          try {

            await document.fonts.ready;

          } catch {

            // Continue.

          }

        }

        await waitForImages(

          exportNode

        );

        await new Promise(

          (

            resolve

          ) => {

            requestAnimationFrame(

              () => {

                requestAnimationFrame(

                  resolve

                );

              }

            );

          }

        );

        const exportWidth =

          760;

        const exportHeight =

          Math.ceil(

            exportNode.scrollHeight

          );

        const dataUrl =

          await toPng(

            exportNode,

            {

              cacheBust:

                true,

              pixelRatio:

                3,

              width:

                exportWidth,

              height:

                exportHeight,

              backgroundColor:

                '#f3dfad',

              style: {

                margin:

                  '0',

                transform:

                  'none',

              },

            }

          );

        const safeName =

          safeFilePart(

            record.fullName,

            'Guest'

          );

        const safeCode =

          safeFilePart(

            record.registrationCode,

            'PASS'

          );

        const category =

          safeFilePart(

            passMeta

              ?.category ||

            'PASS',

            'PASS'

          );

        const fileName =

          `COS-${category}-${safeName}-${safeCode}.png`;

        const imageResponse =

          await fetch(

            dataUrl

          );

        const imageBlob =

          await imageResponse.blob();

        const objectUrl =

          URL.createObjectURL(

            imageBlob

          );

        const link =

          document.createElement(

            'a'

          );

        link.href =

          objectUrl;

        link.download =

          fileName;

        link.style.display =

          'none';

        document.body.appendChild(

          link

        );

        link.click();

        document.body.removeChild(

          link

        );

        window.setTimeout(

          () => {

            URL.revokeObjectURL(

              objectUrl

            );

          },

          1500

        );

      } catch (

        err

      ) {

        console.error(

          'Download pass error:',

          err

        );

        setDownloadError(

          'Unable to download your pass right now. Please try again.'

        );

      } finally {

        setDownloading(

          false

        );

      }

    };

  /* =========================================================

     LOADING

  ========================================================= */

  if (

    loading

  ) {

    return (

      <div className="verify-page">

        <div className="verify-state-card">

          <div className="verify-state-spinner" />

          <span>

            COS BIRTHDAY CELEBRATION

          </span>

          <h2>

            Verifying Your Pass

          </h2>

          <p>

            Please wait while we authenticate

            your personalised event credential.

          </p>

        </div>

      </div>

    );

  }

  /* =========================================================

     ERROR

  ========================================================= */

  if (

    error ||

    !record

  ) {

    return (

      <div className="verify-page">

        <div className="verify-state-card">

          <div className="verify-state-error">

            !

          </div>

          <span>

            PRIVATE EVENT ACCESS

          </span>

          <h2>

            Pass Not Found

          </h2>

          <p>

            {

              error ||

              'This pass is invalid.'

            }

          </p>

        </div>

      </div>

    );

  }

  /* =========================================================

     VERIFIED PASS

  ========================================================= */

  return (

    <>

      <div

        className={`verify-page verify-page--${passMeta.key}`}

      >

        <motion.div

          className={`verify-card verify-card--screen verify-card--${passMeta.key}`}

          initial={{

            opacity:

              0,

            y:

              24,

            scale:

              0.985,

          }}

          animate={{

            opacity:

              1,

            y:

              0,

            scale:

              1,

          }}

          transition={{

            duration:

              0.5,

          }}

        >

          <PassContent

            record={

              record

            }

            showDownloadButton

            downloading={

              downloading

            }

            downloadError={

              downloadError

            }

            onDownload={

              handleDownloadPass

            }

          />

        </motion.div>

      </div>

      {/* =====================================================

          OFF-SCREEN FIXED WIDTH EXPORT

      ===================================================== */}

      <div

        className="verify-export-host"

        aria-hidden="true"

      >

        <div

          ref={

            exportPassRef

          }

          className={`verify-card verify-card--export verify-card--${passMeta.key}`}

        >

          <PassContent

            record={

              record

            }

          />

        </div>

      </div>

    </>

  );

}